<div class="one-whole-oauth ml-oauth">
    <h2 class="heading-oauth ">{{'OAuth Realm Credentials'|translate}}</h2>
    <p class="p-oauth">{{'The credentials that are used in authentication'|translate}}</p>
    <div class="one-whole-oauth">
        <div><input class="btn-outhcred addoauthbtn" (click)="addOauth(addOauthCredentials)" type="button"
                value="{{'ADD'|translate}}">
        </div>
        <table class="table__thin tablesorter table">
            <thead class="table__headings">
                <tr>
                    <th class="cname-w-oauth">{{'Credentials Name'|translate}}</th>
                    <th class="cname-w-oauth">{{'Realm'|translate}}</th>
                    <th class="cid-w-oauth">{{'Client ID'|translate}}</th>
                    <th class="cid-w-oauth">{{'Client Secret'|translate}}</th>
                    <th class="cid-w-oauth">{{'Token URL'|translate}}</th>
                    <th class="cid-w-oauth"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of oauthList;">
                    <td>{{i.name}}</td>
                    <td>{{i.oauthType}}</td>
                    <td>{{i.clientID}}</td>
                    <td>{{i.clientSecret}}</td>
                    <td>{{i.tockenURL}}</td>
                    <td class="buttontd-oauth">
                        <input class="btn-outhcred" (click)="properties(i.id,i.name,i.oauthType,
                        i.clientID,i.clientSecret,i.tockenURL,i.oauth_realm_id)"  type="button"
                        value="{{'PROPERTIES'|translate}}">&nbsp;
                        <input class="btn-outhcred" (click)="deleteOAuthdata(i.id,deletePopUpOauth)" type="button"
                            value="{{'DELETE'|translate}}">&nbsp;
                        <input class="btn-outhcred" (click)="updateOAuthdata(i.id,i.name,i.oauthType,
                            i.clientID,i.clientSecret,i.tockenURL,updateOauthCredentials)" type="button"
                            value="{{'UPDATE'|translate}}">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #addOauthCredentials let-modal>
        <div class="popup-border-oauth">
            <div class="modal-header-oauth">
                <span class="header-popup-text-oauth">{{'Add new realm credentials'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-oauth-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="input-box-oauth">
                {{'Credentials Name'|translate}}
                <select name="oauthListnameadd" [(ngModel)]="oauthListnameadd" class="pop-w-input-oauth"
                    id="oauthListnameadd">
                    <option value="pleaseSelect" selected>{{'Please Select'|translate}}</option>
                    <option *ngFor="let i of serviceroles" [value]="i.serviceName">
                        <span>{{i.serviceName}}</span>
                    </option>
                </select>
                <div *ngIf="errorname"><span class="adderror-oauth">{{'Please Select Credentials
                        Name'|translate}}</span></div>
                <div *ngIf="errornamepresent"><span class="adderror-oauth">{{'Credentials Name Already
                        Exists'|translate}}</span></div>
                {{'Realm'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListrealmadd" [(ngModel)]="oauthListrealmadd">
                <div *ngIf="errorrealm"><span class="adderror-oauth">{{'Please enter the Realm'|translate}}</span></div>
                <div *ngIf="errorrealmlen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                {{'Client ID'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListclientIDadd"
                    [(ngModel)]="oauthListclientIDadd">
                <div *ngIf="errorclientIDadd"><span class="adderror-oauth">{{'Please enter the Client
                        ID'|translate}}</span></div>
                <div *ngIf="errorclientIDaddlen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                {{'Client Secret'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListclientSecretadd"
                    [(ngModel)]="oauthListclientSecretadd">
                <div *ngIf="errorclientSecretadd"><span class="adderror-oauth">{{'Please enter the Client
                        Secret'|translate}}</span></div>
                <div *ngIf="errorclientSecretaddlen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                {{'Token URL'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListtokenUrladd"
                    [(ngModel)]="oauthListtokenUrladd">
                <div *ngIf="errortokenUrladd"><span class="adderror-oauth">{{'Please enter the Token
                        URL'|translate}}</span></div>
                <div *ngIf="errortokenUrladdlen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                <div *ngIf="validtokeninadd"><span class="adderror-oauth">The provided URL was invalid</span></div>
            </div>
            <div class="modal-footer">
                <input class="input-btn-oauth" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmitupdateoauthAdd(oauthListnameadd,oauthListrealmadd,
                oauthListclientIDadd,oauthListclientSecretadd,oauthListtokenUrladd)">
                &nbsp;&nbsp;<input class="input-btn-oauth" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariables()">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #updateOauthCredentials let-modal>
        <div class="popup-border-oauth">
            <div class="modal-header-oauth">
                <span class="header-popup-text-oauth">{{'Update existing realm credentials'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-oauth-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="input-box-oauth">
                {{'Credentials Name'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListname" [(ngModel)]="oauthListname" readonly>
                {{'Realm'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListrealm" [(ngModel)]="oauthListrealm">
                <div *ngIf="errorrealmupdate"><span class="adderror-oauth">{{'Please enter the Realm'|translate}}</span>
                </div>
                <div *ngIf="errorrealmupdatelen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                {{'Client ID'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListclientID" [(ngModel)]="oauthListclientID">
                <div *ngIf="errorclientIDupdate"><span class="adderror-oauth">{{'Please enter the Client
                        ID'|translate}}</span></div>
                <div *ngIf="errorclientIDupdatelen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                {{'Client Secret'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListclientSecret"
                    [(ngModel)]="oauthListclientSecret">
                <div *ngIf="errorclientSecretupdate"><span class="adderror-oauth">{{'Please enter the Client
                        Secret'|translate}}</span></div>
                <div *ngIf="errorclientSecretupdatelen"><span class="adderror-oauth">The specified credentials name is
                        too long</span></div>
                {{'Token URL'|translate}}
                <input type="text" class="pop-w-input-oauth" name="oauthListtokenUrl" [(ngModel)]="oauthListtokenUrl">
                <div *ngIf="errortokenUrlupdate"><span class="adderror-oauth">{{'Please enter the Token
                        URL'|translate}}</span></div>
                <div *ngIf="errortokenUrlupdatelen"><span class="adderror-oauth">The specified credentials name is too
                        long</span></div>
                <div *ngIf="validtokeninup"><span class="adderror-oauth">The provided URL was invalid</span></div>
            </div>
            <div class="modal-footer">
                <input class="input-btn-oauth" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmitupdateoauthUpdate(oauthListrealm,oauthListclientID,
                oauthListclientSecret,oauthListtokenUrl)">
                &nbsp;&nbsp;<input class="input-btn-oauth" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariables()">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-sm">
    <ng-template #deletePopUpOauth let-modal>
        <div class="popup-border-oauth">
            <div class="modal-header-oauth">
                {{'Delete Credential'|translate}}
                <i class="fa fa-times mng-qualifier-close-btn close-oauth-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="padding-oauth">
                <label>{{'Are you sure you want to delete this Credential'|translate}}</label>
            </div>
            <div class="modal-footer">
                <input class="input-btn-oauth" type="button" value="{{'Ok'|translate}}"
                    (click)="modal.dismiss('deletePopUp');deletePopcredential();">
                &nbsp;&nbsp;
                <input class="input-btn-oauth" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariables()">
            </div>
        </div>
    </ng-template>
</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top-oauth" style="display: block;"
    (click)="topFunction()">